import defaultCardImg from '../../assets/image/88/card/default-card.png'
import debitCardLogo from '../../assets/image/88/debit-card-logo.png'
import cardIntroApply from '../../assets/image/88/introduce/card-intro-apply.png'
import cardIntroDisplay from '../../assets/image/88/introduce/card-intro-display.png'
import cardIntroPos from '../../assets/image/88/introduce/card-intro-pos.png'
import cardIntroVip from '../../assets/image/88/introduce/card-intro-vip.png'
import simpleLogo from '../../assets/image/88/simpleLogo.png'

export const debitCard = {
  defaultCardImg: defaultCardImg,
  debitCardLogo: debitCardLogo,
  cardRadius: '12px',
  simpleLogo: simpleLogo,
  introduceImgs: {
    cardIntroApply,
    cardIntroDisplay,
    cardIntroPos,
    cardIntroVip,
  },
} as PlatformConfig['debitCard']
